import {
  dynamicKidDocumentReceivedThunk,
  dynamicTermsheetDocumentReceivedThunk,
} from 'state/dynamic/dynamicForm.thunks';
import { productGovernanceDocumentReceived } from 'state/quotes/regulations/regulation.actions';
import { staticKidDocumentReceivedThunk, staticTermsheetDocumentReceivedThunk } from 'state/static/staticForm.thunks';

export const thunksByWorkspaceAndDoc = {
  static: {
    KID: staticKidDocumentReceivedThunk,
    Termsheet: staticTermsheetDocumentReceivedThunk,
    'MIFID2 target market results': (tabId: string, quoteId: string, doc: any) =>
      productGovernanceDocumentReceived('static', tabId, quoteId, doc, true),
  },
  dynamic: {
    KID: dynamicKidDocumentReceivedThunk,
    Termsheet: dynamicTermsheetDocumentReceivedThunk,
    'MIFID2 target market results': (tabId: string, quoteId: string, doc: any) =>
      productGovernanceDocumentReceived('dynamic', tabId, quoteId, doc, true),
  },
};
